import * as React from "react";

export const Case = () => (
    <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.90186 3.50002C4.90186 2.61637 5.6182 1.90002 6.50186 1.90002H9.50186C10.3855 1.90002 11.1019 2.61637 11.1019 3.50002V4.2954L12.9982 4.29625C13.8819 4.29625 14.5982 5.0126 14.5982 5.89625V12.5C14.5982 13.3837 13.8818 14.1 12.9982 14.1H3.00186C2.1182 14.1 1.40186 13.3837 1.40186 12.5V5.89625C1.40186 5.0126 2.1182 4.29625 3.00186 4.29625H4.90186V3.50002ZM6.10186 4.29625H9.90186V3.50002C9.90186 3.27911 9.72277 3.10002 9.50186 3.10002H6.50186C6.28094 3.10002 6.10186 3.27911 6.10186 3.50002V4.29625ZM3.00186 5.49625C2.78094 5.49625 2.60186 5.67534 2.60186 5.89625V12.5C2.60186 12.7209 2.78094 12.9 3.00186 12.9H12.9982C13.2191 12.9 13.3982 12.7209 13.3982 12.5V5.89625C13.3982 5.67534 13.2191 5.49625 12.9982 5.49625H3.00186Z"
    />
);
